var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "stream-prop" },
    [
      _c("span", { staticClass: "stream-prop__label mr-2" }, [
        _vm._v("Объект:"),
      ]),
      _vm._v(" "),
      _vm.isAccessAllow
        ? _c("TaskObject", {
            attrs: { activeId: _vm.activeId },
            on: { setActive: _vm.setActive },
          })
        : _c("span", [
            _vm._v(_vm._s(this.stream.description_object?.name || "не задан")),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }